<diV class="flex justify-start items-center border-b text-[#737791]  border-[#02578E]/40 mb-6 ">
    @for(tab of tabs;track $index){
        <div [ngClass]="tab==selectedTab?'bg-[#02578E] px-8 py-2 text-[#ffe029] selected':'px-6 py-2' " class="cursor-pointer hover:bg-[#02578E] rounded-t-md hover:px-8 hover:text-[#ffe029]" (click)="selectedTab=tab;onTabChange.emit(tab)">{{tab}}</div>
    }
</diV>
